import { ActionType } from './';

const defaultState = {
  children: null,
  show: false,
}

const popup = (state: any = defaultState,  action: ActionType) => {
  switch (action.type) {
    case 'SHOW_POPUP':
      return {
        ...state,
        children: action.children,
        onClose: action.onClose,
        show: true,
      };
    case 'CLOSE_POPUP':
      return {
        ...state,
        children: null,
        onClose: null,
        show: false
      }

    default:
      return state
  }
}

export default popup



// WEBPACK FOOTER //
// ./src/reducers/popup.ts